import React from "react";
import { SocialAuth } from "./SocialAuth";

interface BlueskyProps {
  register: any;
  watch: any;
}

export function Bluesky({ register, watch }: BlueskyProps) {
  return (
    <>
      <fieldset className="fieldset bg-base-200 border-base-300 rounded-box border p-4">
        <legend className="fieldset-legend">Bluesky Instance</legend>
        <label className="label">
          <span className="label-text">Instance URL</span>
        </label>
        <input
          placeholder="username.bsky.social"
          {...register("instance_url")}
          className="input w-full"
        />
        <p className="label">
          Enter the Bluesky instance URL (default: username.bsky.social)
        </p>
      </fieldset>
      <SocialAuth
        platform="bluesky"
        title="Bluesky"
        showRefreshButton={true}
        instanceUrl={watch("instance_url")}
      />
    </>
  );
}
